var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.attachments),function(attachment){return _c('div',{key:attachment.attachmentId},[_c('v-switch',{attrs:{"value":_vm.selectedAttachments.includes(attachment.attachmentId),"label":attachment.fileName,"hide-details":""},on:{"change":function($event){return _vm.changeState($event, attachment.attachmentId)}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }